var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.distinte && _vm.distinte.length > 0
        ? _c(
            "v-list",
            { attrs: { "two-line": "" } },
            [
              _vm._l(_vm.distinte, function (dist, i) {
                return [
                  i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
                  _c("ItemListDistintaConsumi", {
                    key: dist.id,
                    attrs: { "data-test": "lista-distinte", distinta: dist },
                  }),
                ]
              }),
            ],
            2
          )
        : _c(
            "v-alert",
            {
              staticStyle: { margin: "0 24px" },
              attrs: { text: "", type: "info" },
            },
            [
              _vm._v(
                " Nessuna distinta trovata per i parametri specificati... "
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }